define([], function() {
    'use strict';

    var has = function(obj, key) {
        return obj != null && hasOwnProperty.call(obj, key);
    };

    return has;
});
